//import Libraries
import React from 'react';
import PropTypes from 'prop-types';

//import Components
import {FormGroup, Col, Label, Input} from 'reactstrap';

//import Styles
import './ArticleDateFormGroup.css'

import * as dateUtils from '../Utils/dateUtils'

const articleDateFormGroup = (props) => {
    const valid = dateUtils.validateDate(props.value);

    return (
        <FormGroup 
            row
            disabled={props.disabled}
        >
            <Label sm={1} size="sm"><b>{props.label}</b></Label>
            <Col sm={10}>
                <Input
                    className={valid ? "valid" : "not-valid"}
                    type={props.type}
                    name={props.name}
                    onChange={props.onChange}
                    value={props.value}
                    placeholder='yyyy/mm//dd'
                    bsSize="sm"
                />
                {
                    !valid && (
                        <div>
                            형식에 맞게 입력하세요
                        </div>
                    )
                }
            </Col>
        </FormGroup>
    );
}
export default articleDateFormGroup;

articleDateFormGroup.defaultProps = {
    disabled : false
}



// WEBPACK FOOTER //
// ./src/pages/Admin/HomepageManager/ArticleManager/Elements/ArticleDateFormGroup.js